module.exports = __webpack_public_path__ + "img/1555747131.a4256a04.jpg";